import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import Head from "next/head";
import NavBar from "@/components/templates/NavBar";
import Slider from "@/components/templates/Slider";
import Slideshow from "@/components/templates/Slideshow";
import Footer from "@/components/templates/Footer";
import Newsletter from "@/components/templates/Newsletter";
import ContactWeddingsGroups from "@/components/templates/ContactWeddingsGroups";
import Booking from "@/components/templates/Booking";
import Hero from "@/components/organisms/Hero";
import SectionLeaf from "@/components/templates/SectionLeaf";
import SectionStains from "@/components/templates/SectionStains";
import IconSlider from "@/components/organisms/IconSlider";
import romanceImg from "@/images/weddings&groups/romance/romance-img.webp";
import groupsImg from "@/images/weddings&groups/groups/grupos.webp";
// import instalationsImg1 from "@/images/weddings&groups/instalations/meeting.webp";
// import instalationsImg2 from "@/images/weddings&groups/instalations/pool.webp";
// import instalationsImg3 from "@/images/weddings&groups/instalations/jacuzzi.webp";
// import instalationsImg4 from "@/images/weddings&groups/instalations/spa.webp";
// import instalationsImg5 from "@/images/weddings&groups/instalations/sports-courts.webp";
// import instalationsImg6 from "@/images/weddings&groups/instalations/concierge.webp";
// import instalationsImg7 from "@/images/weddings&groups/instalations/medical-service.webp";
import Title from "@/components/atoms/Title";
import { addConditionalNoIndexTag } from "@/utils/helpers";
// import welcomeimg1 from "@/images/weddings&groups/welcome/welcome-1.webp";
// import welcomeimg2 from "@/images/weddings&groups/welcome/welcome-2.webp";
// import welcomeimg3 from "@/images/weddings&groups/welcome/welcome-3.webp";
// import welcomeimg4 from "@/images/weddings&groups/welcome/welcome-4.webp";
// import welcomeimg5 from "@/images/weddings&groups/welcome/welcome-5.webp";


// const welcomeImages = [
//   welcomeimg1,
//   welcomeimg2,
//   welcomeimg3,
//   welcomeimg4,
//   welcomeimg5,
// ];
// const instalations = [
//   instalationsImg1,instalationsImg2,instalationsImg3,instalationsImg4,instalationsImg5,instalationsImg6,instalationsImg7
// ]
export default function Page(props) {
  const { noIndex } = props;
  const { t } = useTranslation("common", "weddings&groups");
  const sectionOneTexts = t("weddings&groups:sectionOne.text", {
    returnObjects: true,
  });
  const sectionTwoTexts = t("weddings&groups:sectionTwo.text", {
    returnObjects: true,
  });
  const sliders = t("weddings&groups:sliders", { returnObjects: true });
  const SliderComponent = t("weddings&groups:sliderWithTitle.components", {
    returnObjects: true,
  });
  const welcomeImages = t("weddings&groups:welcomeImages", { returnObjects: true })
  const instalations = t("weddings&groups:instalationsImages", { returnObjects: true })
  const welcomeComponent = SliderComponent?.map((item, key) => {
    return (
      <Hero
        key={`wg-${key}`}
        title={{
          text: item.title,
          tag: 'h3',
          className: "text-[18px] lg:text-[24px] text-main-blue text-center hero-title",
        }}
        paragraphs={{
          list: item.text,
          className: "hero-text mb-4 text-center text-[12px] lg:text-[16px]",
        }}
        styles={{
          textContainer: "col-start-2 col-span-10 order-1",
          titleContainer: "col-start-2 col-span-10 order-2",
          paragraphsContainer: "col-start-2 col-span-10 order-3",
          heroContainer: "col-span-12",
        }}
      />
    );
  });
  const groupsImg = t("weddings&groups:groupsImg", { returnObjects: true });
  const instalationImages = t("weddings&groups:instalationsImages", { returnObjects: true });
  addConditionalNoIndexTag();
  return (
    <>
      <Head>
        <title>{t("weddings&groups:meta.title")}</title>
        <meta
          name="description"
          content={t("weddings&groups:meta.description")}
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="keywords" content={t("weddings&groups:meta.keywords")} />
        {noIndex && <meta name="robots" content="noindex" />}
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href={t('common:canonical_pages.weddings-groups')} />
      </Head>
      <main>
        <NavBar />
        <Booking />
        <div className="block md:hidden">
        <Slider grayContainer="false" sliders={sliders?.mobile} />
        </div>
        <div className="hidden md:block">
        <Slider grayContainer="false" sliders={sliders?.desktop} />
        </div>
        <section className="bg-main-blue-light">
          <div className="base-container pt-12">
          <div className="base-grid">
          <div className="col-start-2 col-span-10 order-1">
          </div>
          </div>
          </div>
          <Hero
            title={{ text: t("weddings&groups:welcome.title"), tag:"h1" }}
            text={{
              text: t("weddings&groups:welcome.subtitle"),
              className: "section-subtitle text-center uppercase",
            }}
            paragraphs={{
              list: t("weddings&groups:welcome.text", { returnObjects: true }),
              className: "hero-text mb-4 text-center text-[14px] lg:text-[16px]",
            }}
            styles={{
              textContainer: "col-start-2 col-span-10 order-1",
              titleContainer: "col-start-2 col-span-10 order-2",
              paragraphsContainer: "col-start-2 col-span-10 order-3",
              heroContainer: "base-container pb-12",
            }}
          />
          <div className="block md:hidden">
          <Slideshow
            images={welcomeImages}
            counter={false}
            galleryLink={false}
            isPagination={true}
            classes={{
              mbImage: "mb-10",
              themeColor: "#00205C"
            }}
          />
          </div>
          <div className="hidden md:block">
            <Slideshow
            images={welcomeImages}
            counter={false}
            galleryLink={false}
            isPagination={false}
          />
          </div>
        </section>
        <SectionLeaf
          title={{ 
            text: t("weddings&groups:sectionOne.title"),
            tag: "h2",
          }}
          subtitle={{ 
            text: t("weddings&groups:sectionOne.subtitle") || "",
            className: "section-subtitle text-center text-[14px] lg:text-[16px]"
          }}
          link={{
            text: t("weddings&groups:sectionOne.linkName"),
            href: t("routes:/weddings"),
            className: "hero-link text-[14px] lg:text-[16px]"
          }}
          paragraphs={{
            list: sectionOneTexts,
            className: "hero-text mb-4 text-[14px] lg:text-[16px]",
          }}
          mainImage={{ mainImage: romanceImg }}
          styles={{
            sectionContainer: "pt-12",
          }}
        />
        <SectionStains
          title={{ text: t("weddings&groups:sectionTwo.title"), tag: "h2", }}
          paragraphs={{
            list: sectionTwoTexts,
            className: "hero-text mb-4 text-[14px] lg:text-[16px]",
          }}
          link={{
            text: t("weddings&groups:sectionOne.linkName"),
            href: t("routes:/groups"),
            className: "hero-link text-[14px] lg:text-[16px]"
          }}
          mainImage={{ mainImage: groupsImg }}
          styles={{
            sectionContainer: " ",
          }}
        />
        <section className="bg-white">
          <Hero
            title={{ text: t("weddings&groups:sliderWithTitle.title"), tag: "h2", }}
            text={{
              text: t("weddings&groups:sliderWithTitle.subtitle"),
              className: "section-subtitle text-center uppercase section-subtitle text-center text-[14px] lg:text-[16px]",
            }}
            styles={{
              textContainer: "col-start-2 col-span-10 order-1",
              titleContainer: "col-start-2 col-span-10 order-2",
              paragraphsContainer: "col-start-2 col-span-10 order-3",
              heroContainer: "base-container py-12",
            }}
          />
          <div className="block md:hidden">
          <Slideshow
            images={instalationImages}
            counter={false}
            galleryLink={false}
            childrenItems={welcomeComponent}
            isPagination={true}
            classes={{
              mbImage: " ",
              mbDivOptional: "mb-7",
              themeColor: "#00205C",
            }}
            secondView={true}
          />
          </div>
          <div className="hidden md:block">
          <Slideshow
            images={instalations}
            counter={false}
            galleryLink={false}
            childrenItems={welcomeComponent}
            isPagination={false}
            secondView={false}
          />
          </div>
        </section>
        <IconSlider items={[]} />
        <ContactWeddingsGroups />
        <Newsletter gtmFormId="weddigns-newsletter" />
        <Footer />
      </main>
    </>
  );
}

export async function getServerSideProps({ locale }) {
  const noIndex = process.env.ENV_NO_INDEX || false;
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        "common",
        "weddings&groups",
        "routes",
      ])),
      noIndex,
    },
  };
}
